"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.concat.js");

var _endpoints = require("./endpoints.js");

var _intlTools = require("@nackle/intl-tools");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _default(_x, _x2, _x3) {
  return _ref.apply(this, arguments);
}

function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token, bundleName, locale) {
    var response, bundle;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("".concat(_endpoints.cmxUrl, "/bundle/").concat(encodeURIComponent(bundleName)), {
              method: 'POST',
              headers: {
                'content-type': 'application/json',
                'authorization': "Bearer ".concat(token)
              },
              body: JSON.stringify({
                locales: [locale]
              })
            });

          case 3:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 12;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            bundle = _context.sent;
            (0, _intlTools.updateLanguageBundle)(bundle.bundles[locale]);
            return _context.abrupt("return", {
              success: true
            });

          case 12:
            return _context.abrupt("return", {
              success: false
            });

          case 13:
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              success: false
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
  return _ref.apply(this, arguments);
}
//# sourceMappingURL=content.js.map